import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { TextField } from 'components/Field/TextField';
import { ICONS } from 'components/Icon';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { PageEmpty } from 'components/PageEmpty';
import { PageHeader } from 'components/PageHeader';
import { useAlert } from 'hooks/useAlert';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  doSettingsIntegrationCreate,
  NAVIGATE_MODAL_BACK,
} from 'store/actions';
import { selectSettingsIntegrationPartners } from 'store/remote/selectors';

export const IntegrationAddModal: React.FC<
  ModalScreenProps<ModalScreens.SettingsIntegrationAdd>
> = ({ route }) => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const partners = useSelector(selectSettingsIntegrationPartners);
  const partnerList = Object.values(partners);
  const [integrationName, setIntegrationName] = React.useState('');
  const [selectedPartnerId, setSelectedPartnerId] = React.useState<
    string | null
  >(null);

  const createIntegration = () => {
    const name = integrationName.trim();
    if (!name) {
      alert({ text: 'Integration name is required' });
      return;
    }
    if (!selectedPartnerId) {
      alert({ text: 'Integration partner is required' });
      return;
    }

    dispatch(
      doSettingsIntegrationCreate({
        organisationId: route.params.organisationId,
        integrationPartnerId: selectedPartnerId,
        integrationName: name,
      }),
    );
  };

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Add Integration"
          onPressCloseButton={() =>
            dispatch(NAVIGATE_MODAL_BACK([ModalScreens.SettingsIntegrationAdd]))
          }
          onPressSaveButton={partnerList.length ? createIntegration : null}
        />
      }
    >
      {partnerList.length ? (
        <>
          <Card label="Integration Name" required>
            <TextField
              label="Integration name"
              required
              placeholder="Enter integration name"
              maxLength={256}
              value={integrationName}
              onChange={setIntegrationName}
              onChangeDebounceMs={0}
            />
          </Card>

          <Card
            label="Integration Partner"
            explanation="Choose an integration partner. The new integration is created disabled so you can configure it safely before enabling it."
          >
            {partnerList.map((partner) => (
              <CardRow
                key={partner.uid}
                label={partner.name}
                label2={`${partner.optionCount} feature options · ${partner.configurationCount} configuration options`}
                radioValue={selectedPartnerId === partner.uid}
                onPress={() => setSelectedPartnerId(partner.uid)}
              />
            ))}
          </Card>
        </>
      ) : (
        <PageEmpty
          icon={ICONS.ExclamationSolid}
          text="No Integration Partners Available"
        />
      )}
    </Page>
  );
};
